<template>
  <div class="page-content section-activity-log">
    <div class="model app-page one-chat bulma-dropdown b-modal">
      <vue-headful title="ALICE | Activity Log"></vue-headful>
      <div class="column-wrapper">
        <div class="single-page-full">
          <div class="navbar-wrapper">
            <nav class="navbar no-padding" role="navigation">
              <div class="navbar-start">
                <div class="navbar-item">
                  <label class="label title-label">Activity Log</label>
                </div>
              </div>
            </nav>
          </div>
          <div class="page-content">
            <div class="user-list w-100">
              <label for class="label sub-label p-2">
                <span>Activity Log&nbsp;</span>
                <span class="tag is-info is-rounded">{{ valueTotal }}</span>
              </label>
              <div class="flex-section section-table-activitylog">
                <div class="section-filter-activity-log mb-3 d-flex">
                  <select v-model="filterCategory" class="select small p-1" @change="changeCategory">
                    <option v-for="(categoryKey, index) in Object.keys(filterDataActionsOfCategory)" :value="categoryKey" :key="index">
                      {{ categoryLabels[categoryKey] || categoryKey }}
                    </option>
                  </select>
                  <select v-model="filterActions" class="select small p-1" :class="{ disabled: !filterCategory }" @change="filterDataActions">
                    <option v-for="action in filterDataActionsOfCategory[filterCategory]" :value="action" :key="action">{{ action }}</option>
                  </select>
                  <div
                    class="
                  small
                  bulma-dropdown
                  d-flex
                  align-items-center
                "
                  >
                    <b-dropdown id="date-filter" aria-role="list" position="is-bottom-left" class="float-right">
                      <div class="btn-link text-secondary" slot="trigger" role="button">
                        <font-awesome-icon class="text-primary-300 mr-1" icon="calendar" style="color: #dbdbdb"></font-awesome-icon>
                        {{ dateFilter.toUpperCase() }}
                        <i class="fa fa-angle-down ml-1"></i>
                      </div>
                      <b-dropdown-item aria-role="listitem" @click="toggleDateFilter('today')">
                        Today
                      </b-dropdown-item>
                      <b-dropdown-item aria-role="listitem" @click="toggleDateFilter('yesterday')">
                        Yesterday
                      </b-dropdown-item>
                      <b-dropdown-item aria-role="listitem" @click="toggleDateFilter('last7days')">
                        Last 7 days
                      </b-dropdown-item>
                      <b-dropdown-item aria-role="listitem" @click="toggleDateFilter('last28days')">
                        Last 28 days
                      </b-dropdown-item>
                      <b-dropdown-item aria-role="listitem" @click="toggleDateFilter('custom')">
                        Custom
                      </b-dropdown-item>
                    </b-dropdown>
                    <date-range-picker
                      v-show="dateFilter === 'custom'"
                      v-model="dateRange"
                      :ranges="false"
                      :show-dropdowns="true"
                      :maxDate="maxDate"
                      opens="left"
                      @update="toggleDateFilter('custom')"
                    >
                      <div slot="input" slot-scope="picker">{{ formatDate(picker.startDate) }} - {{ formatDate(picker.endDate) }}</div>
                    </date-range-picker>
                  </div>
                  <input type="text" placeholder="Search name or email" class="input-search-name-or-email double" @change="onSearchName" />
                  <select v-model="filterUserRole" class="select small p-1" @change="filterDataActions">
                    <option v-for="role in userRoleOptions" :value="role" :key="role">{{ role }}</option>
                  </select>
                </div>
                <div v-if="datashow.length" class="section-container-table-activitylog">
                  <VueTabulator ref="tabulator" v-model="datashow" :options="options" class="tableactivitylog" />
                  <div class="pagination-wrapper d-flex justify-content-end p-3">
                    <input class="mr-2" type="number" :value="valuePageSize" @input="updateValue" :max="100" :min="1" />
                    <b-pagination
                      :total="valueTotal"
                      v-model="valuePage"
                      :size="'is-small'"
                      :per-page="valuePageSize"
                      first-text="First"
                      prev-text="Prev"
                      next-text="Next"
                    ></b-pagination>
                  </div>
                </div>
                <div v-else class="d-flex align-items-center flex-column">
                  <div class="text-center"><h4>No results found</h4>Try adjusting your search or filter to find what you're looking for.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="showModelModal" :canCancel="['x']" hide-footer>
      <div class="card">
        <header class="card-header">
          <div class="card-header-title">
            {{ dataDescriptionInModal.scope }}
          </div>
        </header>
        <div class="card-content">
          <div class="content">{{ dataDescriptionInModal.data }}</div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script src="https://code.jquery.com/jquery-3.3.1.slim.min.js"></script>
<script>
import moment from 'moment';
import { DateTime } from 'luxon';
import alice from '../../alice-api';
import { debounce } from 'underscore';

export default {
  name: 'activitylog',
  data() {
    return {
      filterCategory: 'ALL_Action_Category',
      filterActions: 'ALL_Method',
      filterUserRole: 'All_User_Role',
      filterUserNameOrEmail: undefined,
      filterDataActionsOfCategory: {
        ALL_Action_Category: ['ALL_Method'],
        AUTHENTICATION: ['ALL_Method', 'LOGIN_SUCCESS'],
        ISSUE: ['ALL_Method', 'DELETE'],
        MODEL: ['ALL_Method', 'CREATE', 'UPDATE', 'DELETE', 'TRAIN', 'IMPORT'],
        MODEL_CATEGORY: ['ALL_Method', 'CREATE', 'UPDATE', 'DELETE'],
        MODEL_QUESTION: ['ALL_Method', 'CREATE', 'UPDATE', 'DELETE'],
        RULE_SET: ['ALL_Method', 'CREATE', 'DELETE'],
        RULE_BASED: ['ALL_Method', 'CREATE', 'UPDATE', 'DELETE'],
        NLP_CONFIG: ['ALL_Method', 'CREATE', 'UPDATE', 'DELETE'],
        NLP_CONFIG_HISTORY: ['ALL_Method', 'RESTORE'],
        ONE_ON_ONE_CHAT: ['ALL_Method', 'CREATE', 'ACTIVATE', 'DEACTIVATE'],
        KEY_VALUE_COLLECTION: ['ALL_Method', 'CREATE', 'UPDATE', 'DELETE', 'IMPORT'],
        KEY_VALUE_ENTRY: ['ALL_Method', 'UPDATE', 'DELETE'],
        PROMOTIONS: ['ALL_Method', 'CREATE', 'UPDATE', 'DELETE', 'IMPORT'],
        USER_MANAGER: ['ALL_Method', 'CREATE', 'UPDATE', 'DELETE'],
      },
      categoryLabels: {
        ALL_Action_Category: 'All Action Category',
        AUTHENTICATION: 'Authentication',
        ISSUE: 'Issue',
        MODEL: 'Model',
        MODEL_CATEGORY: 'Model Category',
        MODEL_QUESTION: 'Model Question',
        RULE_SET: 'Rule Set',
        RULE_BASED: 'Rule Based',
        NLP_CONFIG: 'NLP Config',
        NLP_CONFIG_HISTORY: 'NLP Config History',
        ONE_ON_ONE_CHAT: 'One-on-One Chat',
        KEY_VALUE_COLLECTION: 'Key Value Collection',
        KEY_VALUE_ENTRY: 'Key Value Entry',
        PROMOTIONS: 'Promotions',
        USER_MANAGER: 'User Manager',
      },
      userRoleOptions: ['All_User_Role', 'admin', 'user'],
      showModelModal: false,
      dataDescriptionInModal: '',
      maxDate: moment().toISOString(),
      valuePage: 1,
      valuePageSize: 20,
      valueTotal: '',
      dateFilter: 'last28days',
      dateRange: {
        startDate: moment()
          .startOf('day')
          .toISOString(),
        endDate: moment()
          .endOf('day')
          .toISOString(),
      },
      datashow: [],
      datasort: [],
      filterscope: '',
      filteruserId: '',
      filterusername: '',
      filteremail: '',
      fitertime: {},
      options: {
        layout: 'fitColumns',
        maxHeight: '100%',
        placeholder: 'No data',
        reactiveData: true,
        columnMinWidth: 80,
        headerFilter: true,
        headerSort: true,
        nestedFieldSeparator: '|',
        groupToggleElement: 'arrow',
        columns: [
          {
            title: 'SCOPE',
            field: 'scope',
            formatter: 'select',
            headerFilterPlaceholder: 'select scope',
            headerFilterParams: {
              values: {
                ISSUE: 'Issue',
                MODEL: 'Model',
                MODEL_CATEGORY: 'Model Category',
                MODEL_QUESTION: 'Model Question',
                RULE_SET: 'Rule Set',
                RULE_BASED: 'Rule Based',
                NLP_CONFIG: 'NLP Conflg',
                ONE_ON_ONE_CHAT: 'One On One chat',
                KEY_VALUE_COLLECTION: 'Key value collection',
                KEY_VALUE_ENTRY: 'Key value entry',
                PROMOTIONS: 'Promotions',
                USER_MANAGER: 'User Manager',
              },
              sorter: () => {
                return null;
              },
            },
            headerFilterEmptyCheck: (value) => {
              if (value.length != 0 && this.filterscope != value) {
                this.filterscope = [];
                this.filterscope = value;
                this.calldataactivity();
              } else if (value.length == 0 && this.filterscope != value) {
                this.filteruserId = '';
                this.calldataactivity();
              }
              return value;
            },
          },
          {
            title: 'Type',
            field: 'type',
          },
          {
            title: 'CREATED AT',
            field: 'created_at',
            sorter: () => {
              return null;
            },
          },
          {
            title: 'USERNAME',
            field: 'username',
            sorter: () => {
              return null;
            },
          },
          {
            title: 'USER EMAIL',
            field: 'user_email',
            sorter: () => {
              return null;
            },
          },
          {
            title: 'USER ROLE',
            field: 'user_role',
            sorter: () => {
              return null;
            },
          },
          {
            title: 'Action',
            formatter: this.actionFormatter,
            align: 'center',
            cellClick: this.onActionClick,
          },
        ],
      },
    };
  },
  watch: {
    valuePage: {
      handler: 'calldataactivity',
    },
  },
  mounted() {
    const obj = {};
    obj.untilDate = moment()
      .utcOffset(420)
      .endOf('day')
      .toISOString();
    obj.sinceDate = moment()
      .utcOffset(420)
      .subtract(27, 'days')
      .startOf('day')
      .toISOString();
    obj.granularity = 'day';
    this.fitertime = obj;
    this.calldataactivity();
    $(document).ready(() => {
      $('.tableactivitylog .tabulator-sortable').click(
        function(element) {
          const obj = {};
          let elementasc = document.querySelectorAll('.tabulator-sortable[aria-sort=asc]').length;
          let elementdesc = document.querySelectorAll('.tabulator-sortable[aria-sort=desc]').length;
          if (elementasc + elementdesc === 1) {
            this.datasort = [];
          }
          const field = $(element.currentTarget.attributes['tabulator-field'])[0].value;
          const foundIndex = this.datasort.findIndex((element) => element.field == field);
          const sort = $(element.currentTarget.attributes['aria-sort'])[0].value.toUpperCase();
          if (this.datasort[foundIndex]) {
            this.datasort[foundIndex].direction = sort;
          } else {
            obj.field = field;
            obj.direction = sort;
            this.datasort.push(obj);
          }
          this.calldataactivity();
        }.bind(this),
      );
      // $('.tabulator-header-filter #text-field-container #search-clear').click( function(element) {
      //   console.log("test");
      // });
    });
  },
  methods: {
    actionFormatter() {
      return '<button class="info-btn">Info</button>';
    },
    onActionClick(e, cell) {
      const rowData = cell.getRow().getData();
      this.showModelModal = true;
      this.dataDescriptionInModal = rowData;
    },
    formatDate(str) {
      return moment(str).format('ll');
    },
    toggleDateFilter(value) {
      this.dateFilter = value;
      this.fitertime = {};
      const obj = {};
      obj.untilDate = moment()
        .utcOffset(420)
        .endOf('day')
        .toISOString();
      if (this.dateFilter === 'today') {
        obj.sinceDate = moment()
          .startOf('day')
          .toISOString();
        obj.granularity = 'hour';
      } else if (this.dateFilter === 'yesterday') {
        obj.sinceDate = moment()
          .subtract(1, 'days')
          .startOf('day')
          .toISOString();
        obj.untilDate = moment()
          .subtract(1, 'days')
          .endOf('day')
          .toISOString();
        obj.granularity = 'hour';
      } else if (this.dateFilter === 'last7days') {
        obj.sinceDate = moment()
          .utcOffset(420)
          .subtract(6, 'days')
          .startOf('day')
          .toISOString();
        obj.granularity = 'day';
      } else if (this.dateFilter === 'last28days') {
        obj.sinceDate = moment()
          .utcOffset(420)
          .subtract(27, 'days')
          .startOf('day')
          .toISOString();
        obj.granularity = 'day';
      } else if (this.dateFilter === 'custom') {
        obj.untilDate = moment(this.dateRange.endDate)
          .utcOffset(420)
          .endOf('day');
        obj.sinceDate = moment(this.dateRange.startDate)
          .utcOffset(420)
          .startOf('day');
        const since = moment(obj.sinceDate);
        const until = moment(obj.untilDate);
        const diff = until.diff(since, 'days', true);
        if (diff <= 1) obj.granularity = 'hour';
        else if (diff <= 31) obj.granularity = 'day';
        else obj.granularity = 'month';
      }
      this.fitertime = obj;
      this.calldataactivity();
    },
    changeCategory(value) {
      this.filterActions = 'ALL_Method';
      this.calldataactivity();
    },
    onSearchName: debounce(function(event) {
      const searchText = event.target.value;
      this.filterUserNameOrEmail = searchText;
      this.calldataactivity();
    }, 500),
    filterDataActions(value) {
      this.calldataactivity();
    },
    calldataactivity() {
      const scope = this.filterCategory === 'ALL_Action_Category' ? undefined : [this.filterCategory];
      const type = !this.filterActions || this.filterActions === 'ALL_Method' ? undefined : [this.filterActions];
      const usernameOrEmail = !this.filterUserNameOrEmail ? undefined : this.filterUserNameOrEmail;
      const userRole = !this.filterUserRole || this.filterUserRole === 'All_User_Role'? undefined : this.filterUserRole;
      const arraysort = {
        page: this.valuePage - 1,
        size: this.valuePageSize,
        scope: scope,
        type: type,
        query: usernameOrEmail,
        userRole: userRole,
      };
      this.datasort.length != 0 ? (arraysort['sort'] = this.datasort) : null;
      this.fitertime.length != 0 ? (arraysort['time'] = this.fitertime) : null;
      alice.activityLog(arraysort).then((result) => {
        this.valueTotal = result.data.data.totalElements;
        this.datashow = result.data.data.content;
        this.datashow = this.datashow.map((data) => {
          data.created_at = DateTime.fromISO(data.created_at)
            .setZone('Asia/Bangkok')
            .toFormat('dd/LL/yyyy HH:mm:ss');
          return data;
        });
      });
    },
    updateValue(event) {
      const value = event.target.value;
      if (value <= 100 && value > 0) {
        this.valuePageSize = value;
      }
      this.calldataactivity()
      this.$forceUpdate()
    }
  },
};
</script>
<style lang="scss">
.modal-backdrop {
  z-index: 0;
}
</style>
<style lang="scss" scoped>
.section-table-activitylog {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  max-height: calc(100% - 100px);
  min-height: 300px;
}
.section-filter-activity-log {
  gap: 10px 20px;
  flex-wrap: wrap;
  font-size: 16px;
}
.section-table-activitylog select {
  padding: 5px 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  padding-right: 30px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 16px;
  color: #333;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.section-table-activitylog select option {
  background-color: #fff;
  color: #333;
  padding: 10px;
}
.section-table-activitylog .select:not(.is-multiple) {
  height: 40px;
}
.section-table-activitylog .input-search-name-or-email {
  padding: 5px 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
}
.section-table-activitylog .small {
  flex-grow: 1;
}
.section-table-activitylog .double {
  flex-grow: 6;
}
.section-filter-activity-log .bulma-dropdown {
  width: auto;
  align-items: center;
  margin-top: auto;
  margin-bottom: auto;
  max-width: fit-content;
  gap: 10px;
}
.section-filter-activity-log .bulma-dropdown .dropdown-menu-animation .btn-link {
  display: flex;
  align-items: center;
}
.section-filter-activity-log .bulma-dropdown .vue-daterange-picker {
  min-width: 140px;
}
.tableactivitylog input[type='search']::-webkit-search-cancel-button {
  display: none;
}
.tabulator-header .tabulator-col input {
  color: #000 !important;
}
.pagination .pagination-next,
.pagination .pagination-previous {
  display: none;
}
.table.is-fullwidth {
  margin-bottom: 0px;
}
.table.is-fullwidth th {
  text-transform: uppercase;
}
.icon.issort {
  color: #2196f3;
}
.pagination-link.is-current {
  background-color: #2196f3;
  border-color: #2196f3;
  color: #fff;
}
.tabulator-header .tabulator-col input {
  border: 1px solid #dbdbdb;
  border-radius: 2px;
  background: #fff;
  color: #fff;
  outline: none;
}
.section-container-table-activitylog{
  display: flex;
  flex-direction: column;
  height: 55vh;
}
.tableactivitylog .tabulator-header {
  border-top: 2px solid #ddd;
}
</style>
